export default "__VITE_ASSET__BR69iyTg__"